import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Building2, Plus, Search, AlertTriangle, CheckCircle2, ChevronRight,
  Package, ShoppingCart,
} from 'lucide-react';
import { fournisseurs } from '../data/mockData';

const Fournisseurs = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('tous');

  const filtered = fournisseurs
    .filter((f) => {
      if (filter === 'alertes') return f.documents.some((d) => d.statut === 'a_renouveler');
      if (filter === 'conformes') return f.documents.every((d) => d.statut === 'conforme');
      return true;
    })
    .filter((f) =>
      f.nom.toLowerCase().includes(search.toLowerCase()) ||
      f.contact.toLowerCase().includes(search.toLowerCase()) ||
      f.siret.includes(search)
    );

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1 className="page-title">Fournisseurs</h1>
          <p className="page-subtitle">Comptes references, documents legaux, catalogue et historique commandes</p>
        </div>
        <button className="btn-primary">
          <Plus size={16} /> Ajouter un fournisseur
        </button>
      </div>

      <div className="toolbar">
        <div className="search-input grow">
          <Search size={16} />
          <input
            placeholder="Rechercher un fournisseur, un contact ou un SIRET"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className="seg-control">
          <button className={filter === 'tous' ? 'active' : ''} onClick={() => setFilter('tous')}>
            Tous ({fournisseurs.length})
          </button>
          <button className={filter === 'alertes' ? 'active' : ''} onClick={() => setFilter('alertes')}>
            <AlertTriangle size={12} /> Alertes
          </button>
          <button className={filter === 'conformes' ? 'active' : ''} onClick={() => setFilter('conformes')}>
            <CheckCircle2 size={12} /> Conformes
          </button>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <table className="data-table clickable">
            <thead>
              <tr>
                <th>Fournisseur</th>
                <th>Contact</th>
                <th>SIRET</th>
                <th>Documents legaux</th>
                <th>Catalogue</th>
                <th>Commandes</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((f) => {
                const alertes = f.documents.filter((d) => d.statut === 'a_renouveler').length;
                return (
                  <tr
                    key={f.id}
                    className="hoverable clickable"
                    onClick={() => navigate(`/fournisseurs/${f.id}`)}
                  >
                    <td>
                      <div className="cell-strong">
                        <Building2 size={16} className="cell-icon" />
                        <div>
                          <p>{f.nom}</p>
                          <span className="meta-line">{f.email}</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p>{f.contact}</p>
                      <span className="meta-line">{f.telephone}</span>
                    </td>
                    <td><span className="mono">{f.siret}</span></td>
                    <td>
                      {alertes > 0 ? (
                        <span className="badge badge-warn">
                          <AlertTriangle size={12} /> {alertes} a renouveler
                        </span>
                      ) : (
                        <span className="badge badge-ok">
                          <CheckCircle2 size={12} /> Tous conformes
                        </span>
                      )}
                    </td>
                    <td>
                      <span className="chip chip-sky">
                        <Package size={11} /> {f.nbProduits}
                      </span>
                    </td>
                    <td>
                      <span className="chip chip-sky">
                        <ShoppingCart size={11} /> {f.nbCommandes}
                      </span>
                    </td>
                    <td style={{ width: 28 }}>
                      <ChevronRight size={16} className="arrow-muted" />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {filtered.length === 0 && (
            <div className="empty-state">
              <Building2 size={28} />
              <p>Aucun fournisseur ne correspond a votre recherche.</p>
            </div>
          )}
        </div>
      </div>

      <p className="meta-line" style={{ marginTop: '1rem' }}>
        {filtered.length} fournisseur(s) affiche(s). Cliquez sur une ligne pour consulter la fiche complete.
      </p>
    </div>
  );
};

export default Fournisseurs;
